module.exports = __webpack_public_path__ + "img/Ma.Maritime.Quaywalls.Caissons-18mwidth12m.Dredgedfillmaterial.771d123f.png";